/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const iconConfirm = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" stroke="#F6B673" />
    <path
      d="M14.1333 21.6012C14.1333 21.3562 14.1816 21.1136 14.2754 20.8873C14.3692 20.6609 14.5067 20.4553 14.68 20.2821C14.8534 20.1088 15.0592 19.9714 15.2856 19.8777C15.5121 19.7839 15.7548 19.7357 16 19.7357C16.2451 19.7357 16.4878 19.7839 16.7143 19.8777C16.9408 19.9714 17.1466 20.1088 17.3199 20.2821C17.4932 20.4553 17.6307 20.6609 17.7245 20.8873C17.8184 21.1136 17.8666 21.3562 17.8666 21.6012C17.8666 22.0959 17.67 22.5704 17.3199 22.9203C16.9698 23.2701 16.495 23.4667 16 23.4667C15.5049 23.4667 15.0301 23.2701 14.68 22.9203C14.33 22.5704 14.1333 22.0959 14.1333 21.6012ZM14.3162 10.3988C14.2914 10.1635 14.3163 9.92553 14.3894 9.70043C14.4625 9.47534 14.5821 9.26811 14.7406 9.09221C14.899 8.9163 15.0926 8.77564 15.3089 8.67936C15.5253 8.58308 15.7594 8.53333 15.9962 8.53333C16.233 8.53333 16.4672 8.58308 16.6835 8.67936C16.8998 8.77564 17.0935 8.9163 17.2519 9.09221C17.4103 9.26811 17.53 9.47534 17.6031 9.70043C17.6762 9.92553 17.7011 10.1635 17.6762 10.3988L17.0229 16.9411C17.0009 17.1981 16.8833 17.4376 16.6932 17.612C16.5031 17.7865 16.2543 17.8833 15.9962 17.8833C15.7381 17.8833 15.4894 17.7865 15.2993 17.612C15.1092 17.4376 14.9915 17.1981 14.9696 16.9411L14.3162 10.3988Z"
      fill="#F6B673"
    />
  </svg>
)

const ConfirmIcon = (props) => <Icon component={iconConfirm} {...props} />

export { ConfirmIcon }
